// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__319yx","sr-only":"App_sr-only__1tWxr"};